import React from "react";
import "../../../styles/filter.css";
import { withNamespaces } from 'react-i18next';

const Filter = ({t}) => {
    return (
        <>
            <div className="marginB_title">
                <div className="dropdown filter_todo">
                    <button
                        className="btn dropdown-toggle col-12"
                        type="button"
                        id="dropdownMenuButton1"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                    >
                        <p className="text-filter">{t('moduleFaqs:D.T')}</p>
                    </button>
                    <ul
                        className="dropdown-menu col-12"
                        aria-labelledby="dropdownMenuButton1"
                    >
                        <li>
                            <a className="dropdown-item todo_option" href="#1">
                                {t('moduleFaqs:D.P1')}
                            </a>
                        </li>
                        <li>
                            <a className="dropdown-item todo_option" href="#2">
                                {t('moduleFaqs:D.P2')}
                            </a>
                        </li>
                        <li>
                            <a className="dropdown-item todo_option" href="#3">
                                {t('moduleFaqs:D.P3')}
                            </a>
                        </li>
                        <li>
                            <a className="dropdown-item todo_option" href="#4">
                                {t('moduleFaqs:D.P4')}
                            </a>
                        </li>
                        <li>
                            <a className="dropdown-item todo_option" href="#5">
                                {t('moduleFaqs:D.P5')}
                            </a>
                        </li>
                        <li>
                            <a className="dropdown-item todo_option" href="#6">
                                {t('moduleFaqs:D.P6')}
                            </a>
                        </li>
                        <li>
                            <a className="dropdown-item todo_option" href="#7">
                                {t('moduleFaqs:D.P7')}
                            </a>
                        </li>
                        <li>
                            <a className="dropdown-item todo_option" href="#8">
                                {t('moduleFaqs:D.P8')}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </>
    );
};

export default withNamespaces() (Filter);
